module.exports = __webpack_public_path__ + "img/hangtian.a500143e.png";